import { render, staticRenderFns } from "./Fund-NavViewspNextView.vue?vue&type=template&id=3da8889d&scoped=true&"
import script from "./Fund-NavViewspNextView.vue?vue&type=script&lang=js&"
export * from "./Fund-NavViewspNextView.vue?vue&type=script&lang=js&"
import style0 from "./Fund-NavViewspNextView.vue?vue&type=style&index=0&id=3da8889d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8889d",
  null
  
)

export default component.exports